<script>
    import { getContext } from 'svelte';
    import { geoPath } from 'd3-geo';

    export let dataKey;
    export let projection;

    const { streets } = getContext(dataKey);
    $: features = $streets.features || [];

    const path = geoPath(projection);
</script>


<g>
    {#each features as street}
        <path
            fill="transparent"
            stroke="currentColor"
            stroke-width="0.5"
            opacity="0.6"
            d={path(street)}
        />
    {/each}
</g>